// extracted by css-extract-rspack-plugin
export default {"anchorRoot":"anchorRoot-NwSche"};